import { render, staticRenderFns } from "./5000.vue?vue&type=template&id=159469ca&lang=pug&"
import script from "./5000.vue?vue&type=script&lang=ts&"
export * from "./5000.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports